const errorPrinter = {
    data: () => {
        return {
            defaultErrorMessage:
                'cannot get any data, please check your connection',
            unauthorizedErrorMessage:
                'your account is not activated or token expired'
        };
    },
    computed: {
        currentEnv() {
            return process.env.NODE_ENV;
        }
    },
    methods: {
        printError(err) {
            // eslint-disable-next-line
            if (this.currentEnv === 'development') console.log(err);
            if (err.response && err.response.status === 401) {
                this.$message.error(this.unauthorizedErrorMessage, 3);
                this.$router.push({ name: 'login' });
            } else {
                if (err.response) {
                    let errorCause = err.response.data.error.cause;
                    let errorMessage = '';
                    if (Array.isArray(errorCause)) {
                        errorMessage = errorCause.reduce((acc, n) => {
                            return acc + ',\n ' + n.message;
                        }, '');
                    } else {
                        errorMessage = errorCause;
                    }
                    this.$message.error(errorMessage, 3);
                } else {
                    this.$message.error(this.defaultErrorMessage, 3);
                }
            }
        }
    }
};

export default errorPrinter;
